import { Component, OnInit, ChangeDetectorRef, NgZone, ViewChild, ElementRef, ViewEncapsulation, HostListener } from '@angular/core';
import * as M from "materialize-css/dist/js/materialize";
//import { AngularFireDatabase } from 'angularfire2/database';
import * as _moment from 'moment';
import { saveAs } from 'file-saver';
import { DateTimeAdapter } from 'ng-pick-datetime';
//import * as Chartist from 'chartist';
import { AuthService, DataService } from '../../_services';
import { Chart, registerables } from 'chart.js';
import { environment } from '../../../environments/environment';

@Component({
  selector: 'app-usage-tracking',
  templateUrl: './usage-tracking.component.html',
  styleUrls: ['./usage-tracking.component.css'],
  //encapsulation : ViewEncapsulation.Native
  //changeDetection: ChangeDetectionStrategy.Default
})
export class UsageTrackingComponent implements OnInit {
  @ViewChild('chtBarUsage', {read:null, static:false}) chtBarUsage: ElementRef;

  public selectedMomentStart = new Date();
  public selectedMomentEnd = new Date();
  public selectedMoment = [new Date(), new Date()];
  public name = '';
  public actionCode = '';
  chkBox: any;


  constructor(
    private ngZone: NgZone,
    private changeDetector : ChangeDetectorRef,
    //public db: AngularFireDatabase,
    public svcAuth: AuthService,
    public svcData: DataService,
    dateTimeAdapter: DateTimeAdapter<any>
  ) { 
    //dateTimeAdapter.setLocale('fr-FR'); // change locale to Japanese
    Chart.register(...registerables);
  }
  @HostListener('click', ['$event']) onClick(e) {
    if(e.target.classList.contains('li_area')){
      this.pageData.areaIndex = -1;
      var _title = e.target.innerHTML;
      this.pageData.areas.forEach((rec, iRec)=>{
        if(_title == rec.title){
          this.pageData.areaIndex = iRec
        }
      });
    }
  }
  pageData = {
    account: {
      //fullName: '', email: '', password: '', confirmPassword: '', contactNo: '', imageUrl: '', role: 'ADMIN', title: ''
      fullName: 'Geek', email: 'geek@gmail.com', password: 'pwd4Geek', confirmPassword: 'pwd4Geek', contactNo: '12345678', imageUrl: '', role: 'ADMIN', title: 'Manager'
    },
    viewMode: 'LIST',
    userList: [],
    areas:[],
    areas4Occupancy:[],
    areaIndex: -1,
    inValue: 0, outValue: 0, occupancyValue: 0,
    data: [],
    cDataUsage: [],
    cDataExit: [],
    cDataOccupancy: [],
    autoRefresh: false
  }
  isOneDay = false; 
  isLoading = false;
  area:any;
  usage:any;
  cUsage:any;
  chtUsage:any;
  labels= [];
  count= [];

  ngOnInit() {
    // this.areaListLoad();
    var _self = this;
    window.setInterval(
      function(){ 
        if(_self.pageData.autoRefresh){
          console.log('auto-refresh');
          //_self.dataLoad();
        }
      },
      (environment.autoRefreshSec*1000)
    );
  }
  ngAfterViewInit(){
  }
  
  dataLoad(){
  }
  dataLoad4Occupancy(){
    
  }
  dateChange(){
    if(_moment(this.selectedMoment[0]).format('YYYYMMDD') == _moment(this.selectedMoment[1]).format('YYYYMMDD')){
      this.isOneDay = true;
    }
    else{this.isOneDay = false;}

    this.svcData.usageListByDate(_moment(this.selectedMoment[0]).format('YYYYMMDD000000'), _moment(this.selectedMoment[1]).format('YYYYMMDD235959'), this.name, this.actionCode)
    .subscribe(res => {
    if(res.status == 'OK') {
      this.usage = res;
    };
    });

    this.svcData.usageListByDateChart(_moment(this.selectedMoment[0]).format('YYYYMMDD000000'), _moment(this.selectedMoment[1]).format('YYYYMMDD235959'), this.name, this.actionCode)
    .subscribe(res1 => {
    if(res1.status == 'OK') {
      this.cUsage = res1;
      this.chartBind();
    };
    });
    
  }
  chartIntervals1(){
    var arrHr = [];
    for(var i=0;i<24;i++){
      arrHr.push(i + 'hr');
    }
    return arrHr;
  }  
  
  loading(arg){
    var _self = this;
    this.ngZone.run(()=>{ _self.isLoading = arg; });
  }
  showAlert(msg){
    M.toast({html: msg});
  }
  timeValueList(startHour, endHour){
    var _arr = [];
    for(var i=startHour; i<=endHour; i++){
      _arr.push({time: i+'hr', inValue: 0, outValue: 0, occ: 0});
    }
    return _arr;
  }
  userForm(arg){
    this.pageData.viewMode = 'FORM';
  }  

  chartIntervals(openingTime, closingTime){
    var arrDay = [];
    var _startDay = _moment(openingTime).day();
    var _endDay = _moment(closingTime).day();
    if(_endDay==0) _endDay = 7;
    for(var i=_startDay;i<=_endDay;i++){
      arrDay.push(i + 'hr');
    }
    return arrDay;
  }

  chartBind(){
    this.labels=[];
    this.count = [];
    this.cUsage.data.forEach(x => {  
      this.labels.push(x.code);  
      this.count.push(x.countCode);
    });
    var _hover = { mode: 'nearest', intersect: true };
    var _tooltip = { mode: 'index', intersect: false };
    var _pluginsLegendTooltip:any = {
      legend: { display:false },
          tooltip: { mode: 'index', intersect: false }
    };
    
    var _borderColorH = "rgba(224,224,224,0.5)", _bgColorH = 'rgba(117,117,117,0.1)';
    var _lblToday = 'Today', _lblLastWeek = 'Last Week', _borderHDash = [5,5];
    var _pointBorderColorH = "rgba(224,224,224,1)";

    const ctxUsage = this.chtBarUsage.nativeElement.getContext('2d');
    if(this.chtUsage != null) this.chtUsage.destroy();
    
    //console.log(ctxUsage);
    this.chtUsage = new Chart(ctxUsage, {
      type: 'bar',
      data: {
        labels: this.labels,
        datasets: [
          {
        label: 'Usage Count',
        data: this.count,
        backgroundColor: [
          'rgba(255, 99, 132, 0.2)',
          'rgba(255, 205, 86, 0.2)',
          'rgba(75, 192, 192, 0.2)',
          'rgba(54, 162, 235, 0.2)',
          'rgba(153, 102, 255, 0.2)',
          'rgba(201, 203, 207, 0.2)',
          'rgba(108, 62, 86, 0.5)'
        ], borderColor: "#90caf9",
        borderWidth: 1
      }]
    },
      options: {
        //plugins: _pluginsLegendTooltip,
        maintainAspectRatio: false,
        responsive: true,
        scales: {
          y: {
            beginAtZero: true
          }
        },
      }
    });    
  }

  showHideSysUsers(){
   
  }
}